<template>
  <div class="card-box">
    <div class="head-wrapper">
      <div class="producer-name">可采购 Profile</div>
      <div>{{ data.length }} 件</div>
    </div>

    <div class="goods-wrapper">
      <a-skeleton active v-if="loading" />

      <div v-else-if="data.length > 0">
        <div
          class="goods-card iotplt-cursor-pointer"
          v-for="product in data"
          :key="product.id"
          @click="toNewItems(product.id)"
        >
          <div class="goods-card-head">
            <a-tooltip>
              <template slot="title">
                {{ product.name }}
              </template>
              <div class="goods-name">{{ product.name }}</div>
            </a-tooltip>
            <div class="goods-price">￥{{ product.price | formatFloat }}</div>
          </div>
        </div>
      </div>

      <a-empty v-else />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileGoodsProductCard',
  props: {
    data: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    toNewItems(productId) {
      this.$router.push({
        name: 'new_profile_purchase_item',
        query: { goods_id: productId }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.card-box {
  background-color: #fff;
  padding: 0 10px 10px 0;
  height: calc(100vh - 260px);
  min-height: 400px;
  overflow: hidden;

  .head-wrapper {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;

    .producer-name {
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 70%;
    }
  }

  .goods-wrapper {
    height: calc(100% - 60px);
    padding: 10px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
    }

    &::-webkit-scrollbar-track {
      background: #fff;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 10px;
    }

    .goods-card {
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 10px;
      margin-bottom: 10px;
      min-height: 120px;
      transition: transform .3s;

      &:hover {
        transform: scale(1.01);
        box-shadow: 0 5px 20px -6px @primary-color;
        border-color: @primary-color;
      }

      .goods-card-head {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        .goods-name {
          font-weight: bold;
          white-space: nowrap;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .goods-price {
          font-weight: bold;
          color: @primary-color;
          white-space: nowrap;
          margin-left: 8px;
        }
      }

      .goods-card-content {
        padding: 16px 0 0;
        color: #8c8c8c;
        line-height: 18px;
      }
    }
  }
}
</style>
